import React, { useEffect } from 'react';
import { TypedMemo } from '../../common/types';
import { useUserToken } from '../../../redux/slices/appInfo/hooks';
import { LoadingView } from '../../common/views/LoadingView';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { useQueryParam } from '../../../utils/hooks/useQueryParam';
import { takeCoverDesignLink } from '../../coverEditor/carry/coverDesignLink';

const PublicOnlyRouteControllerComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  const userToken = useUserToken();
  const router = useSMLRouter();
  const queryReturnTo = useQueryParam('returnTo', null, '');
  const coverDesign = useQueryParam('coverDesign', null, '');

  useEffect(() => {
    if (userToken !== null) {
      // A signed-in user who opens the link of the cover maker email goes to put the design on a song.
      const returnTo = takeCoverDesignLink(coverDesign) ?? queryReturnTo;
      if (returnTo !== '') {
        window.location.href = `${window.location.origin}/app/${returnTo}`;
      } else {
        router.replace(SMLRoutes.home);
      }
    }
  }, [coverDesign, queryReturnTo, router, userToken]);

  if (userToken !== null) {
    return <LoadingView />;
  }

  return <>{children}</>;
};

export const PublicOnlyRouteController = TypedMemo(PublicOnlyRouteControllerComponent);
